"use strict";
exports.__esModule = true;
exports.ConfigurationService = void 0;
var configuration_api_1 = require("./configuration.api");
var http_1 = require("../../core/http");
var getConfigurationEngine = function (sessionId) {
    return http_1.Http.get(configuration_api_1.ConfigurationApi.getCofigurationEngine(sessionId));
};
var getConfigurationPlugin = function (sessionId) {
    return http_1.Http.get(configuration_api_1.ConfigurationApi.getCofigurationPlugin(sessionId));
};
exports.ConfigurationService = {
    getConfigurationEngine: getConfigurationEngine,
    getConfigurationPlugin: getConfigurationPlugin
};
//# sourceMappingURL=configuration.service.js.map